import { isLeft } from "fp-ts/Either"

import { fetchConstants } from "./requests"

export function queryConstants(prefix: string) {
  return {
    queryKey: ['constants', prefix],
    queryFn: async () => {
      const result = await fetchConstants(prefix)
      if (isLeft(result)) {
        return null
      }
      return result.right
    },
    staleTime: Infinity,
  }
}
